// WebInfoContext.jsx
import React, {createContext, useState, useEffect} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";

export const GalleryInfoContext = createContext();

// eslint-disable-next-line react/prop-types
export const GalleryInfoProvider = ({children}) => {
    const {i18n} = useTranslation();
    const [galleryInfo, setGalleryInfo] = useState({
        "logoImages": "",
        "processingImages": "",
        "tintedImages": "",
        "tintedHeaderImages": "",
        "coveringImages": "",
        "ourGalleryImages": "",
        "tintedPartnersImages": "",
        "coveringPartnersImages": "",
        "protectionPartnersImages": "",
    });
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const source = axios.CancelToken.source();
        const fetchGalleryInfo = async () => {
            try {
                setIsLoading(true);
                const res = await
                    axios.get(`${process.env.REACT_APP_API_KEY}/arscustom/public/web/gallery-information`);

                setGalleryInfo(res.data);
                setError(null);
            } catch (err) {
                if (!axios.isCancel(err)) {
                    console.error("Error fetching gallery information:", err);
                    setError(err.message);
                }
            } finally {
                setIsLoading(false);
            }
        };

        fetchGalleryInfo();

        return () => {
            source.cancel("Request cancelled due to language change or unmount");
        };
    }, [i18n.language]);

    return (
        <GalleryInfoContext.Provider value={{galleryInfo, isLoading, error}}>
            {children}
        </GalleryInfoContext.Provider>
    );
};